import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import http from '../../utils/api/http';

export const getUsers = createAsyncThunk('users/getUsers', async () => {
    const { data } = await http.get(`api/v1/users`);
    return data.data;
});

export const createUser = createAsyncThunk(
    'users/createUser',
    async (body, { rejectWithValue }) => {
        try {
            const { data } = await http.post('api/v1/user', body);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const editUser = createAsyncThunk(
    'users/editUser',
    async ({ id, body }, { rejectWithValue }) => {
        try {
            const { data } = await http.put(`api/v1/user/${id}`, body);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const deleteUser = createAsyncThunk('users/deleteUser', async (id) => {
    const { data } = await http.delete(`api/v1/user/${id}`);
    return data.data;
});

const initialState = {
    usersLoadingStatus: 'idle',
    users: [],
    errors: {},
};

export const usersSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {},
    extraReducers: {
        [getUsers.pending]: (state, action) => {
            state.usersLoadingStatus = 'loading';
        },
        [getUsers.fulfilled]: (state, action) => {
            state.usersLoadingStatus = 'succeeded';
            state.users = action.payload;
        },
        [getUsers.rejected]: (state, action) => {
            state.usersLoadingStatus = 'failed';
        },
    },
});

/* Selectors */
export const allUsers = (state) => state.users.users;
export const usersLoadingStatus = (state) => state.users.usersLoadingStatus;

export default usersSlice.reducer;
